"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserLight = exports.authorizeUserLight = void 0;
var axios_1 = __importDefault(require("axios"));
var authorizeUserLight = function (token) {
    return axios_1.default.post("/user-light/authorize/".concat(token));
};
exports.authorizeUserLight = authorizeUserLight;
var getUserLight = function () { return axios_1.default.get('/user-light'); };
exports.getUserLight = getUserLight;
